var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternal4List({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11817",
    "data-name": "Rectangle 11817",
    width: 3.713,
    height: 8.827,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Internal_4_List"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Internal_4_List",
    "data-name": "Internal 4_List",
    clipPath: "url(#clip-Internal_4_List)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_664",
    "data-name": "Ellipse 664",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1 1)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20386",
    "data-name": "Group 20386",
    transform: "translate(7.644 5.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15838",
    "data-name": "Group 15838",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32853",
    "data-name": "Path 32853",
    d: "M0,14.76c0-.3.009-.549,0-.794A.439.439,0,0,1,.438,13.5a.43.43,0,0,1,.429.471c0,.444,0,.887,0,1.331a.99.99,0,0,0,.339.789.936.936,0,0,0,1.009.174.938.938,0,0,0,.611-.8,2.284,2.284,0,0,0,.013-.292c0-.417,0-.834,0-1.251a.431.431,0,0,1,.861,0c0,.524.029,1.049-.007,1.57a1.755,1.755,0,0,1-1.16,1.593,1.842,1.842,0,0,1-2.514-1.46A8.045,8.045,0,0,1,0,14.76",
    transform: "translate(0 -8.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32854",
    "data-name": "Path 32854",
    d: "M.01,2.5c0-.228,0-.456,0-.683A1.85,1.85,0,0,1,3.679,1.51a1.339,1.339,0,0,1,.029.273c0,.494,0,.988,0,1.482a.431.431,0,1,1-.862,0c0-.452,0-.905,0-1.358a.993.993,0,0,0-.31-.766.937.937,0,0,0-1.026-.2.937.937,0,0,0-.624.813,2.218,2.218,0,0,0-.012.266c0,.423,0,.846,0,1.269a.421.421,0,0,1-.434.421.421.421,0,0,1-.427-.419c0-.263,0-.527,0-.79",
    transform: "translate(-0.006 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32855",
    "data-name": "Path 32855",
    d: "M3.754,8.6q0-.7,0-1.394a.432.432,0,1,1,.863,0q0,1.411,0,2.823a.432.432,0,0,1-.851.105A.567.567,0,0,1,3.754,10q0-.7,0-1.4",
    transform: "translate(-2.332 -4.195)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternal4List);
export default __webpack_public_path__ + "static/media/Internal 4_List.e4be52d3af7ca6929a68f7fbf9fb8636.svg";
export { ForwardRef as ReactComponent };